var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
import Vue from 'vue';
import { mapState } from 'vuex';
import { getData, saveData } from '../../utils/storage';
import { toYuan } from '../../utils/unit-conversion';
import cookie from '../../cookie/cookie';
export default Vue.extend({
    name: 'violationPush',
    computed: __assign({}, mapState('violationManage', {
        pushReport: 'pushReport',
        pushData: 'pushData',
        vehicleCount: 'vehicleCount',
    }), { isOpenPush: function () {
            return this.pushData && this.pushData.enable;
        },
        pushSelectVehicleCount: function () {
            var scope = this.pushForm.scope;
            var _a = this.vehicleCount, inventoryCount = _a.inventoryCount, signedCount = _a.signedCount;
            var count = 0;
            if (scope.includes('1')) {
                count += signedCount;
            }
            if (scope.includes('2')) {
                count += inventoryCount;
            }
            return count;
        },
        pushAllVehicleCount: function () {
            var _a = this.vehicleCount, inventoryCount = _a.inventoryCount, signedCount = _a.signedCount;
            return inventoryCount + signedCount;
        },
        pushVehicleCountShow: function () {
            var frequency = this.pushForm.frequency;
            var _a = this, pushSelectVehicleCount = _a.pushSelectVehicleCount, pushAllVehicleCount = _a.pushAllVehicleCount;
            var preCost = (pushSelectVehicleCount * Number(frequency) - pushAllVehicleCount * 2) *
                10;
            return preCost > 0 ? preCost : 0;
        } }),
    props: {
        isPush: {
            type: Boolean,
        },
    },
    data: function () {
        return {
            usernameZh: '',
            changeFrequencyEntry: '',
            dialogVisible: false,
            isNewStatus: false,
            frequencySelect: [
                {
                    label: '每月1期',
                    val: '1',
                },
                {
                    label: '每月2期',
                    val: '2',
                },
                {
                    label: '每月3期',
                    val: '3',
                },
                {
                    label: '每月4期',
                    val: '4',
                },
                {
                    label: '每月5期',
                    val: '5',
                },
            ],
            dateNum: [],
            pushForm: {
                enable: true,
                scope: ['1'],
                pushDate: '',
                frequency: '',
                date_1: '',
                date_2: '',
                date_3: '',
                date_4: '',
                date_5: '',
            },
            pushRules: {
                enable: [
                    {
                        required: true,
                        message: '请选择是否开启推送',
                        trigger: 'change',
                    },
                ],
                scope: [
                    {
                        required: true,
                        message: '请选择查询范围',
                        trigger: 'change',
                    },
                ],
                frequency: [
                    {
                        required: true,
                        message: '请选择推送频率',
                        trigger: 'change',
                    },
                ],
            },
        };
    },
    created: function () {
        this.getUsernameZh();
        this.$store.commit('violationManage/update', {
            pushData: null,
        });
        this.$store.dispatch('violationManage/GET_PUSHDATA');
    },
    methods: {
        getUsernameZh: function () {
            this.usernameZh = cookie.getCookie('usernameZh');
        },
        getNewsStatus: function () {
            var usernameZh = this.usernameZh;
            var createTime = this.pushReport.createTime;
            var date = getData(usernameZh + "_push_news_show_date");
            if (!date) {
                saveData(usernameZh + "_push_news_show_date", createTime);
                this.isNewStatus = true;
                return;
            }
            if (createTime === date) {
                this.isNewStatus = false;
            }
            else {
                saveData(usernameZh + "_push_news_show_date", createTime);
                this.isNewStatus = true;
            }
        },
        openPush: function () {
            this.openPushCommon(this.pushData);
        },
        openPushCommon: function (data) {
            this.updateForm(data);
            this.$store.dispatch('violationManage/GET_VEHICLE_COUNT');
            this.dialogVisible = true;
        },
        updateForm: function (data) {
            if (!data)
                return;
            var enable = data.enable, frequency = data.frequency, pushDate = data.pushDate, scope = data.scope;
            this.pushForm = {
                enable: enable,
                frequency: frequency,
                pushDate: pushDate,
                scope: scope.split(','),
                date_1: '',
                date_2: '',
                date_3: '',
                date_4: '',
                date_5: '',
            };
            this.changeFrequencyEntry = 'update';
            this.changeFrequency(frequency);
        },
        changeFrequency: function (val) {
            var _this = this;
            var arr = [];
            var dates = this.pushData && this.pushData.pushDate.split(',');
            var changeFrequencyEntry = this.changeFrequencyEntry;
            for (var i = 0; i < val; i++) {
                arr.push(i + 1);
                dates &&
                    (this.pushForm["date_" + (i + 1)] =
                        changeFrequencyEntry === 'update' ? dates[i] : '');
            }
            changeFrequencyEntry !== 'update' &&
                this.$store.dispatch('violationManage/GET_VEHICLE_COUNT');
            this.dateNum = arr;
            setTimeout(function () {
                _this.$refs['pushForm'].clearValidate();
            }, 1);
            this.changeFrequencyEntry = '';
        },
        getScope: function () {
            this.$store.dispatch('violationManage/GET_VEHICLE_COUNT');
        },
        submitPushMsg: function () {
            var _this = this;
            if (!this.pushForm.enable) {
                this.$refs['pushForm'].clearValidate();
                this.$refs['pushForm'].validateField('enable', function (errorMsg) {
                    if (errorMsg !== '')
                        return false;
                    _this.savePushMsg(_this.pushForm);
                });
                return;
            }
            this.$refs['pushForm'].validate(function (valid) {
                if (!valid)
                    return;
                _this.savePushMsg(_this.pushForm);
            });
        },
        savePushMsg: function (data) {
            var _this = this;
            var date_1 = data.date_1, date_2 = data.date_2, date_3 = data.date_3, date_4 = data.date_4, date_5 = data.date_5, enable = data.enable, frequency = data.frequency, scope = data.scope;
            var configCode = this.pushData ? this.pushData.configCode : '';
            var pushDate = [];
            for (var i = 0; i < frequency; i++) {
                pushDate.push(data["date_" + (i + 1)] || '');
            }
            var params = {
                enable: enable,
                frequency: frequency,
                scope: scope.join(),
                pushDate: pushDate.join(),
                configCode: configCode || '',
            };
            this.$request({
                url: '/proxy/violation/push/upsert',
                method: 'post',
                data: params,
            }).then(function (res) {
                if (res.errorCode === 0) {
                    _this.$message({
                        type: 'success',
                        message: '推送设置成功',
                    });
                    _this.$store.dispatch('violationManage/GET_PUSHDATA');
                    _this.dialogVisible = false;
                }
            });
        },
        openDetailMsg: function (url) {
            window.open(url);
        },
        toHistoryViolation: function () {
            this.$router.push({ name: 'historyViolationQuery' });
        },
        ValidationIsInteger: function (rule, value, callback) {
            var res = /^\s*[1-9][0-9]{0,1}\s*$/;
            var range = rule.range, index = rule.index;
            if (value === '') {
                return callback(new Error('请输入数字'));
            }
            if (!res.test(value)) {
                return callback(new Error('请输入1-31之间的正整数'));
            }
            if (value > 31) {
                return callback(new Error('请输入1-31之间的正整数'));
            }
            var obj = {};
            var flag = false;
            for (var i = 1; i < 6; i++) {
                if (this.pushForm["date_" + i] === '' ||
                    obj[this.pushForm["date_" + i]]) {
                    continue;
                }
                i !== index + 1 && (obj[this.pushForm["date_" + i]] = true);
            }
            if (obj[this.pushForm["date_" + (index + 1)]]) {
                return callback(new Error('推送日期不能相同'));
            }
            return callback();
        },
        validationRepeat: function () {
            this.$refs['pushForm'].validate(function (valid) {
                if (!valid)
                    return;
            });
        },
        changeYuan: function (val) {
            return toYuan(val);
        },
    },
    watch: {
        pushData: function (val) {
            val && val.enable && this.$store.dispatch('violationManage/GET_REPORT');
        },
        isOpenPush: function (val) {
            this.$emit('set-push-status', {
                isOpenPush: val,
            });
        },
        isPush: function (val) {
            val && this.openPushCommon(this.pushData);
            this.$emit('set-switch-push', {
                isPush: true,
            });
        },
        pushReport: function (val) {
            val && this.getNewsStatus();
        },
    },
});
